import {EventEmitter} from 'eventemitter3';
const _event = new EventEmitter();
export default _event;  